import React from 'react';
import PieChartComponent from '@/components/charts/ActivePie';
import type { PieChartData } from '../types';

interface AssetAllocationChartProps {
  pieData: PieChartData[];
}

/**
 * 资产配置分析图表组件
 */
export const AssetAllocationChart: React.FC<AssetAllocationChartProps> = ({ pieData }) => {
  return (
    <div className="rounded-lg bg-white p-4 shadow-md">
      <div className="mb-4 text-base font-semibold text-[#1F1F1F]">资产配置分析</div>
      <div className="min-[500px]:w-[50vw] relative h-[150px] w-full">
        <PieChartComponent
          data={pieData}
          activeIndex={0}
          legendProps={{
            verticalAlign: 'bottom',
            height: 36
          }}
        />
      </div>
    </div>
  );
};
